import img1Front from "../pics/Book1-Front.png";
import img1Side from "../pics/Book1-Page.jpg";
import img1Back from "../pics/Book1-Back.jpg";

import img2Front from "../pics/Book2-Front.jpg";

export const LOCAL_BOOKS = [
  {
    id: "book_1",
    images: [img1Front, img1Side, img1Back],
  },
  {
    id: "book_2",
    images: [img2Front],
  },
];
